import * as st from './styles.module.scss';

export const ButtonEventEnd = (): JSX.Element => {
	return (
		<div className={st.wrapper}>
			<p className={st.title}>Завершено</p>
		</div>
	);
};

